import { gql } from 'graphql-request'

export default gql`
query getVariableRemuneration($contract: String!, $st: String, $sortBy: String) {
  applications {
    variableRemuneration {
      variableRemunerationList(contract: $contract, st: $st, sortBy: $sortBy) {
        reports {
          file
          file_extension
          contract
          date
        }
      }
    }
  }
}`
